module.exports = __webpack_public_path__ + "static/media/3.5c2d48f6.jpg";